/** Canonical default scope room created with every new draft estimate. */
export const DEFAULT_ESTIMATE_ROOM = {
    name: "Job-Wide / General",
    roomType: "general",
    sortOrder: 0,
    isDefaultScope: true,
};
